import React, { useState, useEffect } from 'react';
import { ShoppingCart, Info, X, Check } from 'lucide-react';
import '../styles/CustomizeModal.css';

const CustomizeModal = ({ 
  selectedCake, 
  customization, 
  setCustomization, 
  sizes, 
  ostyaOptions,
  calculatePrice, 
  addToCart, 
  closeCustomizeModal,
  allCakeTypes
}) => {
  // Belső state-ek a formatortához
  const [selectedFlavor, setSelectedFlavor] = useState('');
  const [shapeDescription, setShapeDescription] = useState(''); // Visszatettük a leírást!

  // Alaphelyzetbe állítás nyitáskor
  useEffect(() => {
    setSelectedFlavor('');
    setShapeDescription('');
    if (!selectedCake.isSpecial && sizes && sizes.length > 0 && !customization.size) {
       // Opcionális alapértelmezett beállítás
    }
  }, [selectedCake]);

  if (!selectedCake) return null;

  // Döntés: melyik méretlistát használjuk?
  const currentSizes = selectedCake.isSpecial ? selectedCake.customSizes : sizes;
  
  // Segédváltozó: Eldönti, hogy ez egy fotós torta-e
  const isPhotoCake = selectedCake.id === 'formatorta_foto' || selectedCake.name.includes('Fotó');

  // Kosárba tevés kezelése
  const handleAddToCart = () => {
    if (selectedCake.isSpecial) {
        if (!selectedFlavor) {
            alert("Kérjük válasszon ízt a torta belsejéhez!");
            return;
        }

        let finalName = '';

        if (isPhotoCake) {
            // FOTÓS TORTA LOGIKA
            finalName = `${selectedCake.name} (${selectedFlavor} íz) - Fotó emailben`;
        } else {
            // FIGURÁS TORTA LOGIKA (Kötelező a leírás!)
            if (!shapeDescription.trim()) {
                alert("Kérjük írja le röviden, milyen formát/figurát szeretne!");
                return;
            }
            finalName = `${selectedCake.name} (${selectedFlavor} íz) - Forma: ${shapeDescription}`;
        }
        
        addToCart(finalName); 
        closeCustomizeModal(); 
    } else {
        addToCart(selectedCake.name);
        closeCustomizeModal();
    }
  };

  return (
    <div className="modal-overlay" onClick={closeCustomizeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={closeCustomizeModal}>
            <X size={24} />
        </button>
        
        <div className="modal-header">
          <div className="modal-cake-emoji">{selectedCake.image}</div>
          <h2>{selectedCake.name}</h2>
          <p>{selectedCake.description}</p>
        </div>

        {/* === 1. FORMATORTA SPECIÁLIS BEÁLLÍTÁSOK === */}
        {selectedCake.isSpecial && (
            <div className="customization-section" style={{ background: '#fffcf5', border: '2px solid #D4816F', padding: '15px', borderRadius: '8px' }}>
                
                {/* ÍZVÁLASZTÓ (MINDEN FORMATORTÁNAK KÖZÖS) */}
                <h3 style={{color: '#D4816F', marginTop: 0}}>1. Milyen ízű legyen a belseje? *</h3>
                <select 
                    value={selectedFlavor}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSelectedFlavor(value);
                        setCustomization(prev => ({ ...prev, flavor: value }));
                    }}
                    style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '1rem',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        fontFamily: 'inherit'
                    }}
                >
                   <option value="">-- Válasszon ízt --</option>
                    {allCakeTypes && allCakeTypes
                        .filter(c => !c.isSpecial)
                        .map(c => (
                            <option key={c.id} value={c.name}>{c.name}</option>
                        ))
                    }
                </select>

                {/* FELTÉTELES MEGJELENÍTÉS: FOTÓ VS FIGURA */}
                {isPhotoCake ? (
                    // FOTÓS TORTA - Tájékoztató doboz
                    <div style={{ background: '#FFF8F0', padding: '15px', borderRadius: '8px', borderLeft: '4px solid #D4816F', marginTop: '20px' }}>
                        <h4 style={{ color: '#8B6F47', marginTop: 0, marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            📸 Fénykép elküldése
                        </h4>
                        <p style={{ margin: 0, fontSize: '0.95rem', color: '#4A3728', lineHeight: '1.5' }}>
                            A rendelés sikeres leadása után kérjük, <strong>küldje el nekünk emailben</strong> a kívánt fotót! 
                            <br /><br />
                            Az emailben feltétlenül tüntesse fel a sikeres rendelés után kapott <strong>rendelési azonosítót</strong> is, hogy be tudjuk azonosítani a tortáját.
                        </p>
                    </div>
                ) : (
                    // FIGURÁS TORTA - Szövegdoboz
                    <div style={{ marginTop: '20px' }}>
                        <h3 style={{color: '#D4816F'}}>2. Milyen forma legyen? *</h3>
                        <textarea
                            placeholder="Pl: Focilabda (Real Madrid címerrel), Rózsaszín cica, Vonat, stb."
                            value={shapeDescription}
                            onChange={(e) => setShapeDescription(e.target.value)}
                            rows="3"
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '1rem',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                marginBottom: '1rem',
                                fontFamily: 'inherit',
                                resize: 'vertical'
                            }}
                        />
                        <div style={{
                            display: 'flex',
                            gap: '10px',
                            alignItems: 'start',
                            background: '#fff',
                            padding: '10px',
                            borderRadius: '8px',
                            border: '1px dashed #D4816F',
                            fontSize: '0.9rem',
                            color: '#8B6F47'
                        }}>
                            <Info size={20} style={{minWidth: '20px', color: '#D4816F'}} />
                            <span>
                                <strong>Fontos:</strong> Ha a kért forma túl bonyolult vagy kérdésünk van, 
                                a rendeléskor megadott telefonszámon <strong>visszahívjuk egyeztetni!</strong>
                            </span>
                        </div>
                    </div>
                )}
            </div>
        )}

        {/* === 2. MÉRET VÁLASZTÓ (MINDENKINEK) === */}
        <div className="customization-section" style={{ marginTop: '20px' }}>
          <h3>Válassza ki a méretet</h3>
          <div className="option-grid">
            {currentSizes.map(size => (
              <label key={size.id} className={`option-card ${customization.size === size.id ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="size"
                  value={size.id}
                  checked={customization.size === size.id}
                  onChange={(e) => {
                    setCustomization({...customization, size: e.target.value, ostya: 'none'});
                  }}
                />
                <span className="option-name">{size.name}</span>
                <span className="option-extra">{size.price.toLocaleString('hu-HU')} Ft</span>
                {customization.size === size.id && <Check size={18} className="check-icon" />}
              </label>
            ))}
          </div>
        </div>

        {/* === 3. OSTYA (CSAK HAGYOMÁNYOS TORTÁKNÁL) === */}
        {!selectedCake.isSpecial && (
            <div className="customization-section">
            <h3>Kér-e ostyaképet?</h3>
            <div className="option-grid">
                {ostyaOptions
                    .filter(opt => {
                        const sOption = sizes.find(s => s.id === customization.size);
                        if (!sOption) return true;
                        if (opt.maxPieces && sOption.pieces >= opt.maxPieces) return false;
                        if (opt.minPieces && sOption.pieces < opt.minPieces) return false;
                        return true;
                    })
                    .map(ostya => (
                    <label key={ostya.id} className={`option-card ${customization.ostya === ostya.id ? 'selected' : ''}`}>
                        <input
                        type="radio"
                        name="ostya"
                        value={ostya.id}
                        checked={customization.ostya === ostya.id}
                        onChange={(e) => setCustomization({...customization, ostya: e.target.value})}
                        />
                        <span className="option-name">{ostya.name}</span>
                        {ostya.price > 0 && (
                        <span className="option-extra">+{ostya.price} Ft</span>
                        )}
                        {customization.ostya === ostya.id && <Check size={18} className="check-icon" />}
                    </label>
                ))}
            </div>
            </div>
        )}

        {/* LÁBLÉC: ÁR ÉS GOMB */}
        <div className="modal-footer">
          <div className="modal-price">
            <span>Teljes ár:</span>
            <span className="final-price">
              {(() => {
                  const s = currentSizes.find(x => x.id === customization.size);
                  if (!s) return "0";
                  
                  if (selectedCake.isSpecial) {
                      return s.price.toLocaleString('hu-HU');
                  } else {
                      return calculatePrice(selectedCake, customization.size, customization.ostya).toLocaleString('hu-HU');
                  }
              })()} Ft
            </span>
          </div>
          <button className="add-to-cart-final" onClick={handleAddToCart}>
            <ShoppingCart size={20} />
            Kosárba helyezés
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomizeModal;